import gql from 'graphql-tag';

export const setPersonalInformation = gql`
  mutation setPersonalInformation(
    $userDetails: UserDetailsRecord!
    $educationYear: Int!
    $educationRecord: EducationProfileRecord!
  ) {
    setMyUserDetails(myUserDetails: $userDetails) {
      id
      userDetails {
        firstName
        lastName
      }
    }
    setEducationProfile(educationYear: $educationYear, educationRecord: $educationRecord) {
      educationYear
    }
  }
`;
